import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deletePrintingDetails } from '../../Store/PHPSlice/Printing';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';

const TableBody = ({
    serialNumber,
    id,
    odt,
    oNo,
    itemNm,
    partyNm,
    pritingMatter,
    dpersonNm,
    rpersonNm,
    printsides,
    printQty,
    inwardQty,
    balQty,
    sts,
  
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();

    const handleDeleteClick = () => {
        //Show confirmation dialog
       
            const isConfirmed = window.confirm("Are you sure you want to delete this Printing Details?");

          //  If user confirms, proceed with deletion
            if (isConfirmed) {
                dispatch(deletePrintingDetails(id))
                    .then(() => {
                        // Reload the page to show updated results
                        alert("Printing Details Deleted Sucessfully");
                         window.location.reload();
                    })
                    .catch((error) => {
                        // Handle any errors that occur during the deletion process
                        console.error("Error deleting Item:", error);
                        toast.error("Failed to delete Item");
                    });
             }
        

    };

    const handleViewClick = () => {
        window.open(`/press-info/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };



    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    const handleReturnClick = () => {
        window.open(`/printing-inward/${id}`, '_blank', 'width=1200,height=700,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {odt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {oNo}
                </TableCell>
               

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {partyNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {pritingMatter}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dpersonNm}
                </TableCell>
                 <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {rpersonNm}
                </TableCell>
                   <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {printsides}
                </TableCell>
                  <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {printQty}
                </TableCell>
                   <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {inwardQty}
                </TableCell>
                   <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {balQty}
                </TableCell>
              

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <Button className='cursor-pointer' variant="contained" color="primary" onClick={handleReturnClick} disabled={sts === '1'}>Inward</Button>
                </TableCell>
                        <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon onClick={handleDeleteClick} className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`}/>
                </TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} />
                </TableCell> */}


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
